module.exports = __webpack_public_path__ + "components/Modals/SideDescription/img/schronisko.jpg?5d8455c0";


//////////////////
// WEBPACK FOOTER
// ./components/Modals/SideDescription/img/schronisko.jpg
// module id = 2330
// module chunks = 0